/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {AnimationMetadata, AnimationOptions, ɵStyleData} from '@angular/animations';

import {AnimationDriver} from '../render/animation_driver';
import {normalizeStyles} from '../util';

import {Ast} from './animation_ast';
import {buildAnimationAst} from './animation_ast_builder';
import {buildAnimationTimelines} from './animation_timeline_builder';
import {AnimationTimelineInstruction} from './animation_timeline_instruction';
import {ElementInstructionMap} from './element_instruction_map';
export class Animation {
private _animationAst: Ast;
/**
 * @param {?} _driver
 * @param {?} input
 */
constructor(private _driver: AnimationDriver, input: AnimationMetadata|AnimationMetadata[]) {
    const errors: any[] = [];
    const ast = buildAnimationAst(input, errors);
    if (errors.length) {
      const errorMessage = `animation validation failed:\n${errors.join("\n")}`;
      throw new Error(errorMessage);
    }
    this._animationAst = ast;
  }
/**
 * @param {?} element
 * @param {?} startingStyles
 * @param {?} destinationStyles
 * @param {?} options
 * @param {?=} subInstructions
 * @return {?}
 */
buildTimelines(
      element: any, startingStyles: ɵStyleData|ɵStyleData[],
      destinationStyles: ɵStyleData|ɵStyleData[], options: AnimationOptions,
      subInstructions?: ElementInstructionMap): AnimationTimelineInstruction[] {
    const /** @type {?} */ start = Array.isArray(startingStyles) ? normalizeStyles(startingStyles) : /** @type {?} */((
                                                  <ɵStyleData>startingStyles));
    const /** @type {?} */ dest = Array.isArray(destinationStyles) ? normalizeStyles(destinationStyles) : /** @type {?} */((
                                                    <ɵStyleData>destinationStyles));
    const /** @type {?} */ errors: any = [];
    subInstructions = subInstructions || new ElementInstructionMap();
    const /** @type {?} */ result = buildAnimationTimelines(
        this._driver, element, this._animationAst, start, dest, options, subInstructions, errors);
    if (errors.length) {
      const /** @type {?} */ errorMessage = `animation building failed:\n${errors.join("\n")}`;
      throw new Error(errorMessage);
    }
    return result;
  }
}

function Animation_tsickle_Closure_declarations() {
/** @type {?} */
Animation.prototype._animationAst;
/** @type {?} */
Animation.prototype._driver;
}

